import { type IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { SystemUser } from "@@/shared/users/system-user";
import type { UserId } from "@@/shared/users/user-id";
import { isUserId } from "@@/shared/users/user-id";
import type { AiFredConversation } from "../ai/conversation";
import type { AiFredSocketEventBase } from "./aifred-socket-event-base";
import { createAiFredSocketEventBase } from "./aifred-socket-event-base";
import { aiFredSocketEventDataFactory } from "./aifred-socket-event-data";
import type { AiFredSocketEventTypeName } from "./aifred-socket-event-type-name";

type TypeName = Extract<AiFredSocketEventTypeName, "new_message">;
type AiFredNewMessageSocketEvent = AiFredSocketEventBase<TypeName>;

const aiFredNewMessageSocketEventFactory = (params: {
    conversation: AiFredConversation;
    triggeredBy: UserId | SystemUser;
    triggeredAt: IsoAndUnixTimestamp;
}): AiFredNewMessageSocketEvent => {
    return createAiFredSocketEventBase<TypeName>({
        for: [
            params.conversation.userId,
            ...(isUserId(params.triggeredBy) ? [params.triggeredBy] : []),
        ],
        triggeredBy: params.triggeredBy,
        triggeredAt: params.triggeredAt,
        data: aiFredSocketEventDataFactory({
            conversationId: params.conversation._id,
        }),

        type: "aifred:new_message",
        tags: [],
    });
};
export { aiFredNewMessageSocketEventFactory };
export type { AiFredNewMessageSocketEvent };
